"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('water-rate', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M24,44 C32.836556,44 40,37.4875642 40,29.4545455 C40,21.5757576 34.6666667,13.0909091 24,4 C13.3333333,13.0909091 8,21.5757576 8,29.4545455 C8,37.4877782 15.163444,44 24,44 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("g", {
    transform: "translate(18.000000, 19.000000)",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polyline", {
    points: "0.857142857 0 6 5.36842105 11.1428571 0"
  }), _react.default.createElement("path", {
    d: "M0,7.15789474 L12,7.15789474"
  }), _react.default.createElement("path", {
    d: "M0,12.5263158 L12,12.5263158"
  }), _react.default.createElement("path", {
    d: "M6,7.15789474 L6,17"
  })))));
});

exports.default = _default;